import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Loader2, Plus } from 'lucide-react';
import { SYSTEM_ROLE_OPTIONS } from '../utils/rbacLabels';
import { IITH } from '@/pages/landing/iithBrand';

/** Create-role form card. */
export default function RolesCreateCard({ form, setForm, saving, onCreate }) {
  return (
    <section className="rounded-xl border bg-white p-5 shadow-sm space-y-4" data-testid="roles-create">
      <header>
        <p className="text-sm font-semibold text-zinc-900 flex items-center gap-2">
          <span
            className="h-7 w-7 rounded-lg grid place-items-center text-white"
            style={{ background: IITH.saffron }}
          >
            <Plus className="h-3.5 w-3.5" />
          </span>
          Create a clinic role
        </p>
        <p className="text-xs text-zinc-500 mt-1.5">
          Display name is for people. App access decides which portal the user lands in after login.
          Permissions are mapped separately on the Permissions screen.
        </p>
      </header>
      <div className="grid sm:grid-cols-2 gap-3">
        <div className="sm:col-span-2 space-y-1.5">
          <Label className="text-xs">Display name *</Label>
          <Input
            value={form.name}
            placeholder="e.g. Senior Nurse, OPD Coordinator"
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            data-testid="role-name"
          />
        </div>
        <div className="sm:col-span-2 space-y-1.5">
          <Label className="text-xs">Description</Label>
          <Input
            value={form.description}
            placeholder="What this role is responsible for"
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
        </div>
        <div className="space-y-1.5 sm:col-span-2">
          <Label className="text-xs">App access (system role)</Label>
          <select
            className="w-full h-10 border rounded-md px-3 text-sm"
            value={form.system_role}
            onChange={(e) => setForm({ ...form, system_role: e.target.value })}
          >
            {SYSTEM_ROLE_OPTIONS.map((r) => (
              <option key={r.v} value={r.v}>{r.l}</option>
            ))}
          </select>
        </div>
      </div>
      <Button
        onClick={onCreate}
        disabled={saving}
        style={{ background: IITH.saffron }}
        className="text-white"
        data-testid="role-create"
      >
        {saving ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
        Save role
      </Button>
    </section>
  );
}
